<template>
   <table class="table table-striped account__table account__table--bets account__table--complex">


      <thead class="thead-dark">
         <tr>
            <th scope="col" >
               <t tag="user.page.table.sportbets.ticket_id"/>
               {{ t('') }}</th>
            <th scope="col">
               <t tag="user.page.table.sportbets.created"/>
               </th>
            <th scope="col">
               <t tag="user.page.table.sportbets.product"/>
               </th>
            <th scope="col">
               <t tag="user.page.table.sportbets.ticket_type"/>
            </th>
            <th scope="col">
               <t tag="user.page.table.sportbets.amount"/>
            </th>
            <th scope="col">
               <t tag="user.page.table.sportbets.maxamount"/>
            </th>
            <th scope="col">
               <t tag="user.page.table.sportbets.stake"/>
            </th>
            <th scope="col">
               <t tag="user.page.table.sportbets.status"/>
            </th>
<!--            <th scope="col">{{ t('user.page.table.sportbets.cancel') }}</th>-->
         </tr>
      </thead>
      <tbody

      >
<!--  :key="'bet-'+bet.id" v-for="bet in ticket.bets"       -->
         <tr v-for="ticket in tickets"
             :key="'sportsimpel--'+snakeCase(ticket.ticket_id)">
            <th scope="row">
               <span class="pointer btn btn-link btn-sm btn-open-details" @click="$emit('openBet', ticket.ticket_id)">
                  {{ticket.ticket_id}}
               </span>
            </th>
            <td v-html="betDateString(ticket.created)"></td>
            <td>
               {{ticket.product}}
            </td>
            <td>
               {{ticket.ticket_type}}
            </td>
            <td>
               {{formatToMoney(safeNumber(ticket.stake_amount))}}
            </td>
            <td>
               {{formatToMoney(safeNumber(ticket.winning_max_amount))}}
            </td>
            <td>
               {{formatToMoney(safeNumber(ticket.winning_amount))}}
            </td>
            <td>
               <t v-if="ticket.status" :tag="'user.page.table.sportbets.status.'+ticket.status"/>
            </td>

<!--            <td>
               <i class="fa fa-trash pointer" v-if="isCancelAvailable(bet)" @click="cancelBet(bet)" :title="t('user.page.table.bets.cancel.btn')">

               </i>
            </td>-->
         </tr>
      </tbody>
   </table>

</template>

<script>
export default {
   name: "SportFullTable",
   props:{
      tickets: Array
   },
   methods:{
      betDateString(date){
         date = moment(date);


         return `${date.format('DD/MM/YYYY')}

				${this.formatToTime(date)}`;
      },
      isCancelAvailable(bet){
         return false; //TODO:
      },
      cancelBet(bet){
         this.$emit('cancelBet', bet)
      },

   }
}
</script>

<style scoped>

</style>
